function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment, useState } from 'react';
import clsx from 'clsx';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { normalizeClassnames, spacingToNumber } from '../../../internals/utils';
import SovosCollapse from '../../../sovos-collapse';
import SovosFixedWidthText from '../../../sovos-fixed-width-text';
import SectionHeader from './SectionHeader';
import HEADER from '../../constants/header';
import { hasNestedLinks, isLinkSelected, navigationLinksPropTypes } from './navigationLinksUtils';
import BaseLink from './BaseLink';
import BaseIcon from './BaseIcon';
import BaseSelectedIndicator from './BaseSelectedInidicator';
import BaseToggle from './BaseToggle';
var getIndicatorStyles = function getIndicatorStyles(spacing) {
  return {
    margin: spacingToNumber(spacing(0.625)),
    // 5px
    width: spacingToNumber(spacing(0.5))
  };
};
var StyledLink = styled(BaseLink)(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    margin: "".concat(spacing(0.25), " ").concat(spacing(), " 0 ").concat(spacing()),
    paddingLeft: spacing(0.375),
    // 3px
    paddingRight: spacing()
  };
});
var StyledIcon = styled(BaseIcon)(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    marginRight: spacing()
  };
});
var StyledSelectedIndicator = styled(BaseSelectedIndicator)(function (_ref3) {
  var spacing = _ref3.theme.spacing;
  var indicatorStyles = getIndicatorStyles(spacing);
  return {
    '&.sovosNavigationLinks__linkSelectedIndicator': {
      marginRight: indicatorStyles.margin,
      width: indicatorStyles.width
    }
  };
});
var StyledToggle = styled(BaseToggle)(function (_ref4) {
  var transitions = _ref4.theme.transitions;
  return {
    transition: "transform ".concat(transitions.duration.short, "ms"),
    '&.sovosNavigationLinks__nestedLinksToggle--expanded': {
      transform: 'rotate(90deg)'
    }
  };
});
var LinkText = styled(ListItemText)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
    spacing = _ref5$theme.spacing,
    typography = _ref5$theme.typography;
  var indicatorStyles = getIndicatorStyles(spacing);
  return {
    '&:not(.MuiListItemText-inset) .MuiListItemText-primary': _objectSpread(_objectSpread({}, typography.body1), {}, {
      flex: '1 0 auto',
      marginLeft: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }),
    '&.MuiListItemText-inset': {
      paddingLeft: spacingToNumber(spacing(6)) - indicatorStyles.width - indicatorStyles.margin,
      '& .MuiListItemText-primary': _objectSpread({}, typography.body2)
    }
  };
});
function expandSelectedLink(links, selectedLink) {
  var parentLink = links.find(function (element) {
    if (element.nestedLinks && element.nestedLinks.length > 0) {
      return element.nestedLinks.find(function (e) {
        return isLinkSelected(e, selectedLink);
      }) !== undefined;
    }
    return false;
  });
  if (parentLink) {
    return _defineProperty({}, parentLink.label, true);
  }
  return {};
}
var NavigationLinks = function NavigationLinks(_ref7) {
  var selectedLink = _ref7.selectedLink,
    onLinkClick = _ref7.onLinkClick,
    links = _ref7.links;
  var _useState = useState(expandSelectedLink(links, selectedLink)),
    _useState2 = _slicedToArray(_useState, 2),
    expandedLinks = _useState2[0],
    setExpandedLinks = _useState2[1];
  var handleLinkClick = function handleLinkClick(link) {
    var expand = hasNestedLinks(link);
    if (expand) {
      setExpandedLinks(function (prevState) {
        var isOpen = prevState[link.label] || false;
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, link.label, !isOpen));
      });
    } else {
      onLinkClick(link);
    }
  };
  var renderNestedLinkArrow = function renderNestedLinkArrow(link, isNested) {
    if (!hasNestedLinks(link) || isNested) return null;
    var isExpanded = !!expandedLinks[link.label];
    return /*#__PURE__*/React.createElement(StyledToggle, {
      isExpanded: isExpanded
    });
  };
  var renderIcon = function renderIcon(link, isNested) {
    if (isNested || !link.icon) {
      return null;
    }
    return /*#__PURE__*/React.createElement(StyledIcon, {
      element: link.icon
    });
  };
  var renderNestedList = function renderNestedList(link, isNested) {
    if (!isNested && hasNestedLinks(link)) {
      return /*#__PURE__*/React.createElement(SovosCollapse, {
        in: expandedLinks[link.label],
        timeout: "auto",
        unmountOnExit: true
      }, /*#__PURE__*/React.createElement(List, {
        disablePadding: true
      }, link.nestedLinks.map(function (nestedLink) {
        return (
          // eslint-disable-next-line no-use-before-define
          renderLinkItem(nestedLink, true)
        );
      })));
    }
    return null;
  };
  var shouldShowSelectedIndicator = function shouldShowSelectedIndicator(link) {
    if (isLinkSelected(link, selectedLink)) {
      return true;
    }
    if (hasNestedLinks(link) && !expandedLinks[link.label]) {
      return !!link.nestedLinks.find(function (nl) {
        return isLinkSelected(nl, selectedLink);
      });
    }
    return false;
  };
  var renderLinkItem = function renderLinkItem(link, isNested) {
    var normalizedLinkText = normalizeClassnames(link.label);
    var isSelected = shouldShowSelectedIndicator(link);
    if (link.type === HEADER) {
      return /*#__PURE__*/React.createElement(SectionHeader, {
        key: link.label,
        label: link.label
      });
    }
    return /*#__PURE__*/React.createElement(Fragment, {
      key: link.label
    }, /*#__PURE__*/React.createElement(StyledLink, {
      isDisabled: link.disabled,
      isNested: isNested,
      isSelected: isSelected,
      onClick: link.disabled ? null : function () {
        return handleLinkClick(link);
      }
    }, /*#__PURE__*/React.createElement(StyledSelectedIndicator, {
      element: "div",
      isSelected: isSelected
    }), renderIcon(link, isNested), /*#__PURE__*/React.createElement(LinkText, {
      inset: isNested,
      className: clsx('sovosNavigationLinks__linkText', "sovosNavigationLinks__linkText-".concat(normalizedLinkText)),
      primary: /*#__PURE__*/React.createElement(SovosFixedWidthText, {
        text: link.label,
        toolTipText: link.toolTip
      })
    }), renderNestedLinkArrow(link, isNested)), renderNestedList(link, isNested));
  };
  return /*#__PURE__*/React.createElement(List, {
    className: "sovosNavigationLinks"
  }, links.map(function (link) {
    return renderLinkItem(link);
  }));
};
NavigationLinks.propTypes = navigationLinksPropTypes;
export default NavigationLinks;